
  import { defineComponent, inject } from "vue";

  import BaseProcessComponentV2 from "@/components/processComponents/v2/BaseProcessComponentV2.vue";
  import { ContextKeys } from "@/enums/contextKeys.enum";
  import { Events } from "@/enums/events.enum";
  import { get } from "lodash";

  export default defineComponent({
    name: "SimpleSwitchV2",

    extends: BaseProcessComponentV2,

    setup(props: any) {
      const root: string = props.path.split(".")[0];

      return {
        [root]: inject(root),
      };
    },

    methods: {
      async handleOnChange() {
        await this.processEvent({
          events: this.resolvedClientSideEvents,
          eventName: `$this.${Events.CHANGE}`,
          context: {
            [ContextKeys.THIS]: this,
            [ContextKeys.FORM]: get(this, this.root, {}),
          },
        });
      },
    },
  });
